import HttpService from "../http.services";

const apiManagementService = new HttpService(process.env.REACT_APP_API_URL);

class EmpresaServiceGlobal {
  // Sin sesión: nombre, color y logo para pintar la marca (también en el inicio de sesión).
  getMarca = async () => apiManagementService.get("/apiglobal/v1/empresa/marca");

  // Configuraciones > Empresa (solo Super Administrador).
  getEmpresa = async () => apiManagementService.post("/apiglobal/v1/configuracion/empresa", {});

  guardar = async (payload = {}) => apiManagementService.post("/apiglobal/v1/configuracion/empresa/guardar", payload);

  // `pequeno`: la versión cuadrada (barra lateral contraída e ícono de la pestaña).
  guardarLogo = async (logo, pequeno = false) =>
    apiManagementService.post("/apiglobal/v1/configuracion/empresa/logo", { logo, pequeno });

  eliminarLogo = async (pequeno = false) =>
    apiManagementService.post("/apiglobal/v1/configuracion/empresa/logo/eliminar", { pequeno });
}

const empresaServiceGlobalInstance = new EmpresaServiceGlobal();

export default empresaServiceGlobalInstance;
